/**
 * Gets locale from the DOM (HTML lang attribute)
 *
 * @return {?string} - HTML lang attribute or null if somehow lang attribute is missing
 *
 * @example
 * // returns 'en-GB' (<html lang="en-GB" ...>)
 * getLocaleFromDOM()
 */
const getLocaleFromDOM = () => document.documentElement.lang || null;
export default getLocaleFromDOM;
//# sourceMappingURL=getLocaleFromDOM.js.map